import React from 'react';

export const AlertListItem = ({ alert, isSelected, handleAlertSelect }) => (
    <div onClick={() => handleAlertSelect(alert)} className={'mobile-reader-alert ' + (isSelected ? 'mobile-reader-alert--active' : '')}>
        <span>{alert.name}</span>
        <span className="mobile-reader-alert__cnt">{alert.countNews}</span>
    </div>
);
